export default __webpack_public_path__ + "static/media/footer-background.58cf6b67.svg";